import { createContext } from 'react';
import type { DeferredActionContextValue } from '../types/deferred-action.types';

export const DeferredActionContext =
  createContext<DeferredActionContextValue | null>(null);
